import type { CheckoutCartHistoryItem, Kiosk } from '@gozoki/api-types'
import { type UseQueryResult, useQuery } from '@tanstack/react-query'
import { fetchCheckoutKiosks, fetchRecentCheckoutCarts } from '../queries/checkoutKiosk.queries'

const checkoutStaleTime = (refetchInterval: number | false): number =>
  typeof refetchInterval === 'number'
    ? Math.min(Math.max(refetchInterval - 1000, 4000), 30_000)
    : 30_000

export const useCheckoutKiosks = (
  storeId: number,
  enabled = true,
  refetchInterval: number | false = 5000,
): UseQueryResult<Kiosk[], unknown> =>
  useQuery({
    queryKey: ['checkout', storeId],
    queryFn: () => fetchCheckoutKiosks(storeId),
    enabled,
    refetchInterval,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    staleTime: checkoutStaleTime(refetchInterval),
  })

export const useRecentCheckoutCarts = (
  storeId: number,
  enabled = true,
  refetchInterval: number | false = 5000,
): UseQueryResult<CheckoutCartHistoryItem[], unknown> =>
  useQuery({
    queryKey: ['checkout', storeId, 'recent-carts'],
    queryFn: () => fetchRecentCheckoutCarts(storeId),
    enabled,
    refetchInterval,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    staleTime: checkoutStaleTime(refetchInterval),
  })
